import React from "react";
import AttachmentList from "./AttachmentList";
import AttachmentSummary from "./AttachmentSummary";
import AttachmentUploadButton from "./AttachmentUploadButton";
import { ATTACH_FILES_TEXT, LAYOUT_CLASS } from "./attachmentPanel.constants";
import {
  getAttachmentPanelState,
  getPanelClassName,
} from "./attachmentPanel.state";
import "../../commonComponent/colorChangingBorder.css";

/**
 * Attachment panel for a note: lists every saved and freshly selected file
 * (up to the shared attachment cap) with per-file download, remove, and
 * undo-removal actions.
 */
const NoteAttachmentPanel = ({
  acceptedFileTypes,
  isDisabled = false,
  isHighlighted = false,
  onClearSelectedFile,
  onDownloadAttachment,
  onRemoveSavedAttachment,
  onSelectFiles,
  onUndoRemoveSavedAttachment,
  pendingRemovalBlobNames = [],
  savedAttachments = [],
  selectedFiles = [],
}) => {
  const panelState = getAttachmentPanelState({
    isDisabled,
    pendingRemovalBlobNames,
    savedAttachments,
    selectedFiles,
  });

  return (
    <section
      className={getPanelClassName(isHighlighted)}
      data-testid="note-attachment-panel"
    >
      <div className={LAYOUT_CLASS}>
        <AttachmentSummary
          countText={panelState.attachedCountText}
          hasAttachments={panelState.hasAttachments}
        />
        <AttachmentUploadButton
          acceptedFileTypes={acceptedFileTypes}
          isDisabled={panelState.isUploadDisabled}
          label={ATTACH_FILES_TEXT}
          onSelectFiles={onSelectFiles}
        />
      </div>
      <AttachmentList
        onClearSelectedFile={onClearSelectedFile}
        onDownloadAttachment={onDownloadAttachment}
        onRemoveSavedAttachment={onRemoveSavedAttachment}
        onUndoRemoveSavedAttachment={onUndoRemoveSavedAttachment}
        rows={panelState.attachmentRows}
      />
    </section>
  );
};

export default NoteAttachmentPanel;
